import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const VALUES = [
  { icon: '🎯', title: 'Simplicity First', desc: 'We believe powerful tools should be simple to use. No technical knowledge needed — if you can use WhatsApp, you can use MS Reach.' },
  { icon: '🔒', title: 'Your Data is Safe', desc: 'We never sell your data. Your contacts, campaigns, and leads are yours — always. GDPR and Indian data privacy compliant.' },
  { icon: '🚀', title: 'Built for India', desc: 'Designed for Indian businesses — INR pricing, GST invoicing, Indian bank transfers, and Tamil Nadu GST (CGST+SGST) support built in.' },
  { icon: '💬', title: 'Real Support', desc: 'Talk to a real person — not a bot. Our team is available Monday to Saturday, 10AM to 6PM IST via email and WhatsApp.' },
];

const MILESTONES = [
  { year: '2024', title: 'Idea Born', desc: 'Founded in Salem, Tamil Nadu after seeing local businesses lose leads from their websites daily.' },
  { year: '2025', title: 'Platform Built', desc: 'Built the complete WhatsApp marketing + CRM platform with 157+ features in under 12 months.' },
  { year: '2026', title: 'MS Reach Launched', desc: 'Officially launched MS Reach to help businesses across India capture and convert more leads.' },
];

export default function About() {
  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>

        {/* Hero */}
        <section style={{ padding: '120px 24px 80px', textAlign: 'center', position: 'relative' }}>
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.015) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.015) 1px,transparent 1px)', backgroundSize: '60px 60px', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: 600, height: 600, background: 'radial-gradient(circle, rgba(0,231,76,0.05) 0%, transparent 65%)', pointerEvents: 'none' }} />
          <div style={{ maxWidth: 800, margin: '0 auto', position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'inline-block', background: 'rgba(0,231,76,0.08)', border: '1px solid rgba(0,231,76,0.2)', color: 'var(--green)', padding: '6px 18px', borderRadius: 100, fontSize: 12, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 20 }}>About Us</div>
            <h1 style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 'clamp(32px,5vw,60px)', color: '#fff', lineHeight: 1.1, marginBottom: 24, letterSpacing: -1 }}>
              We Help Businesses<br /><span style={{ color: 'var(--green)' }}>Never Miss a Lead</span>
            </h1>
            <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.55)', lineHeight: 1.8, maxWidth: 680, margin: '0 auto 40px' }}>
              MS Reach was born from a simple observation — hundreds of local businesses in India were losing customers every day because their websites had no instant way to connect. We built the solution.
            </p>
          </div>
        </section>

        {/* Story */}
        <section style={{ padding: '80px 24px', borderTop: '1px solid var(--border)' }}>
          <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}>
            <div>
              <div style={{ display: 'inline-block', background: 'rgba(0,231,76,0.08)', border: '1px solid rgba(0,231,76,0.2)', color: 'var(--green)', padding: '5px 14px', borderRadius: 100, fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 16 }}>Our Story</div>
              <h2 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 32, color: '#fff', marginBottom: 20, lineHeight: 1.2 }}>Built in Salem,<br />for Businesses Everywhere</h2>
              <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)', lineHeight: 1.85, marginBottom: 16 }}>
                MS Discoveries started as a small digital agency in Paramathi Velur, Namakkal. Working with local businesses, we kept seeing the same problem — people visited websites but left without contacting anyone.
              </p>
              <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)', lineHeight: 1.85, marginBottom: 16 }}>
                The solution was obvious: connect websites directly to WhatsApp, the app every Indian uses daily. So we built MS Reach — a complete platform for WhatsApp marketing, lead capture, and CRM.
              </p>
              <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)', lineHeight: 1.85 }}>
                Today, MS Reach helps businesses across India respond to leads faster, run WhatsApp campaigns at scale, and never let a customer slip through the cracks.
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {MILESTONES.map((m, i) => (
                <div key={i} style={{ display: 'flex', gap: 16, alignItems: 'flex-start', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
                  <div style={{ background: 'var(--green)', color: '#000', padding: '6px 12px', borderRadius: 8, fontFamily: 'Sora', fontWeight: 800, fontSize: 13, flexShrink: 0 }}>{m.year}</div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#fff', marginBottom: 4 }}>{m.title}</div>
                    <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', lineHeight: 1.6 }}>{m.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section style={{ padding: '80px 24px', background: 'rgba(0,231,76,0.015)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
          <div style={{ maxWidth: 800, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 40, textAlign: 'center' }}>
            {[['157+', 'Platform Features'], ['4', 'Flexible Plans'], ['5000+', 'Messages / Day']].map(([val, label]) => (
              <div key={label}>
                <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 48, color: 'var(--green)', lineHeight: 1 }}>{val}</div>
                <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', marginTop: 8 }}>{label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Values */}
        <section style={{ padding: '100px 24px' }}>
          <div style={{ maxWidth: 1000, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <h2 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 36, color: '#fff', marginBottom: 12 }}>What We Stand For</h2>
              <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 15 }}>The principles that guide every decision we make.</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 20 }}>
              {VALUES.map((v, i) => (
                <div key={i} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: 28 }}>
                  <div style={{ fontSize: 36, marginBottom: 16 }}>{v.icon}</div>
                  <div style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 16, color: '#fff', marginBottom: 10 }}>{v.title}</div>
                  <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7 }}>{v.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ padding: '80px 24px', borderTop: '1px solid var(--border)', textAlign: 'center' }}>
          <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <h2 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 32, color: '#fff', marginBottom: 16 }}>Ready to Get Started?</h2>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 15, marginBottom: 32 }}>Join MS Reach and start converting website visitors into WhatsApp leads today.</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <Link to="/register"><button style={{ background: 'var(--green)', color: '#000', border: 'none', padding: '13px 28px', borderRadius: 10, fontFamily: 'Sora', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>Create Account</button></Link>
              <Link to="/contact"><button style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.15)', padding: '13px 28px', borderRadius: 10, fontFamily: 'Sora', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>Contact Us</button></Link>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}
